module.exports = __webpack_public_path__ + "media/dobry_wzor/dobry-wzor-laureat-raport-58d1012c.png";